module.exports = __webpack_public_path__ + "img/logo_ali.9657cc94.png";